module.exports = __webpack_public_path__ + "static/media/bg6.35876be3.jpg";